/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Layout,
  Menu,
  Button,
  Typography,
  Card,
  Form,
  Input,
  // Cascader,
  notification
} from "antd";

import mohLogo from "../assets/images/MOH_LOGO.png";

import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import { apiRoutes } from "../constants/apiRoutes";
// import useAppStore from "../store";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function SignUp() {
  // const setCounties = useAppStore((state) => state.setCounties);
  // const setAuthorities = useAppStore((state) => state.setAuthorities);
  // const authorities = useAppStore((state) => state.authorities);
  // const counties = useAppStore((state) => state.counties);
  const history = useHistory();
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  const openNotificationWithIcon = (config) => {
    api[config.type]({
      key: config.key,
      message: config.message,
      description: config.description,
      duration: 5,
    });
  };

  // useEffect(() => {
  //   axios.get(`${process.env.REACT_APP_DATA_API_URL}${apiRoutes.authorities}`)
  //     .then((res) => {
  //       setAuthorities(res.data);
  //     })
  //     .catch((e) => {
  //       openNotificationWithIcon({
  //         type: 'error',
  //         message: "Error fetching Authorities",
  //         description: e.message
  //       })
  //     });
  //   axios.get(`${process.env.REACT_APP_DATA_API_URL}${apiRoutes.counties}`)
  //     .then((res) => {
  //       setCounties(res.data);
  //     })
  //     .catch((e) => {
  //       openNotificationWithIcon({
  //         type: 'error',
  //         message: "Error fetching Counties",
  //         description: e.message
  //       })
  //     });
  // }, []);

  // const authoritiesOptions = authorities
  //   .map((a) => ({
  //     value: a.name,
  //     label: a.name,
  //   }));
  // const countiesOptions = counties
  //   .sort((a, b) => ('' + a.name).localeCompare(b.name))
  //   .map((c) => ({
  //     value: c.name,
  //     label: c.name,
  //   }));

  // const onChange = (value, selectedOptions) => {
  //   console.log(value, selectedOptions);
  // };
  // const filter = (inputValue, path) => path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);


  const onFinish = (formData) => {
    setLoading(true);
    const values = {
      ...formData,
      authority: formData?.authority?.[0] || "Self",
      county: formData?.county?.[0] || "<UNKOWN_COUNTY>"
    }
    console.log("Success:", { ...values, password: `<has ${values.password.length} characters>` });

    axios.post(`${process.env.REACT_APP_AUTH_API_URL}${apiRoutes.register}`, values)
      .then((res) => {
        setLoading(false);
        var countdownSeconds = 5;
        let countdownIntvl = setInterval(function () {
          countdownSeconds--;

          openNotificationWithIcon({
            key: 'updated',
            type: 'success',
            message: "Registration successful",
            description: `Please sign in with your new account. You'll be redirected in ${countdownSeconds} seconds`
          });

          if (countdownSeconds === 0) {
            clearInterval(countdownIntvl);
            history.push("/sign-in");
          }
        }, 1000);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e.response.data.error);
        openNotificationWithIcon({
          type: 'error',
          message: "Error registering user",
          description: e?.response?.data?.error || e.message
        })
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      {contextHolder}
      <div className="layout-default ant-layout layout-sign-up">
        <Header style={{ justifyContent: 'space-between' }}>
          <div className="header-col header-brand" style={{ display: "flex", alignItems: "center", gap: "1em" }}>
            <img src={mohLogo} alt="" width={30} height={30} />
            <h5>NPHL Dashboards</h5>
          </div>
          <div>
            <Button>
              <Link to="/sign-in">
                Sign In
              </Link>
            </Button>
          </div>
        </Header>

        <Content className="p-0">
          <div className="sign-up-header">
            <div className="content">
              <Title>Sign Up</Title>
              <p className="text-lg">
                Create a new account
              </p>
            </div>
          </div>

          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            title={<h5>Register With</h5>}
            bordered="false"
          >
            {/* <div className="sign-up-gateways">
                <Button type="false">
                  <img src={logo1} alt="logo 1" />
                </Button>
                <Button type="false">
                  <img src={logo2} alt="logo 2" />
                </Button>
                <Button type="false">
                  <img src={logo3} alt="logo 3" />
                </Button>
              </div> */}
            {/* <p className="text-center my-25 font-semibold text-muted">Or</p> */}
            <Form
              name="basic"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="row-col"
              layout="vertical"
            >
              <Form.Item
                name="first_name"
                label="First Name"
                rules={[
                  { required: true, message: "Please input your First Name" },
                ]}
              >
                <Input placeholder="First Name*" />
              </Form.Item>
              <Form.Item
                name="last_name"
                label="Last Name"
                rules={[
                  { required: true, message: "Please input your Last Name" },
                ]}
              >
                <Input placeholder="Last Name*" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input placeholder="Email*" />
              </Form.Item>
              {/* <Form.Item
                label="County"
                name="county"
                rules={[
                ]}
              >
                <Cascader
                  options={countiesOptions}
                  onChange={onChange}
                  placeholder="County"
                  showSearch={{
                    filter,
                  }}
                />
              </Form.Item>
              <Form.Item
                name="authority"
                label="Authority"
                rules={[
                ]}
              >
                <Cascader
                  options={authoritiesOptions}
                  onChange={onChange}
                  placeholder="Authority"
                  showSearch={{
                    filter,
                  }}
                />
              </Form.Item>
              <Form.Item
                name="telephone_number"
                label="Phone"
                rules={[
                ]}
              >
                <Input placeholder="Telephone" />
              </Form.Item> */}
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
              <Form.Item
                name="confirm_password"
                label="Confirm Password"
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The new password that you entered do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm Password" />
              </Form.Item>

              {/* <Form.Item name="remember" valuePropName="checked">
                  <Checkbox>
                    I agree the{" "}
                    <a href="#pablo" className="font-bold text-dark">
                      Terms and Conditions
                    </a>
                  </Checkbox>
                </Form.Item> */}

              <Form.Item>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  SIGN UP
                </Button>
              </Form.Item>
            </Form>
            <p className="font-semibold text-muted text-center">
              Already have an account?{" "}
              <Link to="/sign-in" className="font-bold text-dark">
                Sign In
              </Link>
            </p>
          </Card>
        </Content>
        <Footer>
          <Menu mode="horizontal">
            <Menu.Item>Company</Menu.Item>
            <Menu.Item><Link to="/about">About Us</Link></Menu.Item>
          </Menu>
          <p className="copyright">
            {" "}
            Copyright © {new Date().getFullYear()} National Public Health Laboratories.{" "}
          </p>
        </Footer>
      </div>
    </>
  );
}
